(function () {
  angular.module('app.communications-analytics.quickview', []);

})();